import { render, staticRenderFns } from "./KitBoard.vue?vue&type=template&id=14e042b5"
import script from "./KitBoard.vue?vue&type=script&lang=js"
export * from "./KitBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports